import { inject } from "@angular/core";
import { CanActivateFn, Route, Router } from "@angular/router";
import { AccountSelectionService } from "@front/m19-services";
import { map, take } from "rxjs";

export const readOnlyGuard: CanActivateFn = () => {
  const router = inject(Router);
  const accountSelectionService = inject(AccountSelectionService);

  return accountSelectionService.readOnlyMode$.pipe(
    take(1),
    map((isReadOnly) => {
      if (isReadOnly) {
        return router.createUrlTree(["/home"]);
      }
      return true;
    }),
  );
};

// The account selection lives in the query params: re-run the guard when the user switches account on the page.
export const readOnlyGuarded: Pick<Route, "canActivate" | "runGuardsAndResolvers"> = {
  canActivate: [readOnlyGuard],
  runGuardsAndResolvers: "paramsOrQueryParamsChange",
};
